module.exports = __webpack_public_path__ + "media/images/phone_id_background-a44c78bce1a06085c4605dd98d24c271.png";